import React from 'react';
import { browserHistory } from 'react-router';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import PageHeader from '../PageHeader/PageHeader';
import './Change.scss';
import loader from '../../assets/loading.gif';

class SubmitCase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      submitted: false
    };
    this.handleSend = this.handleSend.bind(this);
  }

  handleSend() {
    this.setState({ submitting: true });
    setTimeout(() => (this.setState({ submitting: false, submitted: true })), 1500);
  }

  render() {
    return (
      <main>
        <PageHeader title="Line Test" />
        {!this.state.submitted &&
        <div className="container">
          <div className="centre text-small">
            Please enter any additional information you can provide about your broadband problem.
          </div>
          <div>
            <textarea
              className="form-control"
              rows={12}
              cols={72}
              placeholder="E.g. My connection stopped working today at midday and has been down since then."
            />
          </div>
          <div className="button-container">
            <Button
              className="btn btn-default btn-secondary"
              onClick={() => browserHistory.push('/line-test')}
              disabled={this.state.submitting}
            >
              Back
            </Button>
            <Button onClick={this.handleSend} disabled={this.state.submitting}>
              {this.state.submitting ?
                <img
                  src={loader}
                  height="20"
                  alt="Loading..."
                  role="presentation"
                /> : 'Submit'}
            </Button>
          </div>
        </div>
        }
        {this.state.submitted &&
        <div className="container">
          <div className="centre text-small">
            Thanks for getting in touch, one of our friendly support people will get back to you within 48 hours.
          </div>
          <div className="button-container">
            <Button onClick={() => browserHistory.push('/dashboard/testInProgress')}>
              Back To Dashboard
            </Button>
          </div>
        </div>
        }
      </main>
    );
  }
}

SubmitCase.propTypes = {
  params: PropTypes.object
};

export default SubmitCase;



/** WEBPACK FOOTER **
 ** ./src/components/Change/SubmitCase.js
 **/